module.exports = __webpack_public_path__ + "img/privacy.9bdc3724.svg";